import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { registeredTabsHandlers } from '@/global/components/view-layouts/tabs-layout/common/registered-tabs-handlers'
import { FORMATS } from '@/global/services/date'

const TAB_KEY = 'basicInfo'

// fields by which we display dynamic fields
const ALARM_TYPE_DEPENDANT_KEY = 'TYPE'
const SENSOR_TYPE_DEPENDANT_KEY = 'SENSOR'

// alarm types
const TYPE_GEOFENCE = 1
const TYPE_OVERSPEED = 2
const TYPE_LOW_VOLTAGE = 3
const TYPE_INACTIVE = 4
const TYPE_FUEL_LEAK = 5
const TYPE_LEGAL_OVERSPEED = 6
const TYPE_DOOR_OPENING = 7
const TYPE_TEMPERATURE_RANGE = 8
const TYPE_ENGINE_RPM_OVERSPEED = 9
const TYPE_SENSORS = 10
const TYPE_UNAUTHORIZED_VEHICLE_USE = 11
const TYPE_DRIVING_WITHOUT_DRIVER = 12
// sensor types
const TYPE_ANALOG = 'analog'
const TYPE_DIGITAL = 'digital'
export default {
  name: 'basicInfo',

  data () {
    return {
      typeDependantFields: {
        maxSpeed: {
          mapKey: 'parameter',
          visible: false
        },
        engineRpmSpeed: {
          mapKey: 'parameter',
          visible: false
        },
        inactivityTime: {
          mapKey: 'parameter',
          visible: false
        },
        voltageLevel: {
          mapKey: 'parameter',
          visible: false
        },
        location: {
          mapKey: 'parameter',
          visible: false
        },
        geofenceEnter: {
          mapKey: 'options',
          visible: false
        },
        sensor: {
          mapKey: 'options',
          visible: false
        },
        speedLimitTolerance: {
          mapKey: 'options',
          visible: false
        },
        allowedVehicleUseFrom: {
          mapKey: 'allowed_vehicle_use_from',
          visible: false
        },
        allowedVehicleUseTo: {
          mapKey: 'allowed_vehicle_use_to',
          visible: false
        },
        ignoreMainLocations: {
          mapKey: 'options.ignore_main_locations',
          visible: false
        },
        ignoreUserAndPartnerLocations: {
          mapKey: 'options.ignore_user_and_partner_locations',
          visible: false
        },
        ignoreUnloadedVehicle: {
          mapKey: 'options.ignore_unloaded_vehicle',
          visible: false
        },
        temperatureRange: {
          mapKey: 'options.temperature_range',
          visible: false
        },
        timeTolerance: {
          mapKey: 'options.time_tolerance',
          visible: false
        },
        active_from: {
          visible: true
        },
        active_to: {
          visible: true
        }
      },
      sensorDependantFields: {
        dinNotifyAfter: {
          mapKey: 'din_notify_after',
          visible: false
        },
        ainNotifyAfter: {
          mapKey: 'ain_notify',
          visible: false
        },
        ainVoltageLimit: {
          mapKey: 'ain_voltage_limit',
          visible: false
        }
      },
      adminFieldsVisibility: {
        user: {
          visible: false
        },
        is_editable: {
          visible: false
        }
      }
    }
  },

  computed: {
    activeDaysItems () {
      return [
        {
          id: 1,
          name: this.$t('base.monday')
        },
        {
          id: 2,
          name: this.$t('base.tuesday')
        },
        {
          id: 3,
          name: this.$t('base.wednesday')
        },
        {
          id: 4,
          name: this.$t('base.thursday')
        },
        {
          id: 5,
          name: this.$t('base.friday')
        },
        {
          id: 6,
          name: this.$t('base.saturday')
        },
        {
          id: 7,
          name: this.$t('base.sunday')
        }
      ]
    },

    notificationTypesItems () {
      return [
        {
          id: 'sms',
          name: this.$t('base.sms')
        },
        {
          id: 'email',
          name: this.$t('base.email')
        },
        {
          id: 'without_notifications',
          name: this.$t('satellite-tracking/alarm.without_notifications')
        }
      ]
    },

    geofenceEnterItems () {
      return [
        {
          id: 'geofenceEnter',
          name: this.$t('satellite-tracking/alarm.geofence_enter')
        },
        {
          id: 'geofenceExit',
          name: this.$t('satellite-tracking/alarm.geofence_exit')
        }
      ]
    },

    dinSensorsNotifyAfterItems () {
      return [
        {
          id: 'activation',
          name: this.$t('satellite-tracking/alarm.notify_after_activation')
        },
        {
          id: 'deactivation',
          name: this.$t('satellite-tracking/alarm.notify_after_deactivation')
        }
      ]
    },

    ainSensorsNotifyAfterItems () {
      return [
        {
          id: 'above_voltage_limit',
          name: this.$t('satellite-tracking/alarm.above_voltage_limit')
        },
        {
          id: 'below_voltage_limit',
          name: this.$t('satellite-tracking/alarm.below_voltage_limit')
        }
      ]
    },

    basicInfoCreateConfig () {
      return {
        title: this.$t('base/profile.basic_info'),
        key: TAB_KEY,
        apiConfig: {
          post: {
            module: 'satellite-tracking',
            route: () => {
              return this.createMode ? 'alarms' : `alarms/${this.$route.params.id}`
            }
          },
          get: {
            module: 'satellite-tracking',
            route: `alarms/${this.$route.params.id}`,
            use: !this.createMode
          }
        },
        afterSave: (event) => this.afterSave(event),
        afterCancel: (event) => this.afterCancel(event),
        dataFetched: (event) => this.onDataFetched(event),
        modifyDataBeforeSend: (event) => this.onModifyDataBeforeSend(event),
        tabContent: [
          // back button, title and edit buttons
          {
            component: this.tabActionsComponent,
            title: this.createMode ? this.$t('satellite-tracking/alarm.adding_new_alarm') : this.$t('satellite-tracking/alarm.alarm_details'),
            showBackButton: {
              onGoBack: () => this.backToMainTable()
            },
            onCancelTabSave: (event) => this.onCancelSave(event)
          },
          // form data
          {
            component: this.columnsContentComponent,
            showButtons: false,
            rows: [
              {
                type: 'fields',
                columnsCount: 4,
                fields: [
                  // always visible fields
                  {
                    key: 'name',
                    label: this.$t('satellite-tracking/alarm.name'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'type_id',
                    label: this.$t('satellite-tracking/alarm.type'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'satellite-tracking',
                      route: 'alarms/types/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true,
                    onChange: (event) => this.onAlarmTypeChange(event)
                  },
                  {
                    key: 'frequency_id',
                    label: this.$t('satellite-tracking/alarm.frequency'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'satellite-tracking',
                      route: 'alarms/frequencies/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'vehicles',
                    label: this.$t('satellite-tracking/alarm.vehicles'),
                    type: 'vehicles-selection',
                    maxSelect: null,
                    creatable: true,
                    editable: true,
                    readonly: true,
                    visible: true
                  },
                  {
                    key: 'active_days',
                    label: this.$t('satellite-tracking/alarm.active_days'),
                    type: 'combobox',
                    autocomplete_options: {
                      fetchInitial: false
                    },
                    items: this.activeDaysItems,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'notification_types',
                    label: this.$t('satellite-tracking/alarm.notification_types'),
                    type: 'combobox',
                    autocomplete_options: {
                      fetchInitial: false
                    },
                    items: this.notificationTypesItems,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'active_from',
                    label: this.$t('satellite-tracking/alarm.active_from'),
                    type: 'datetime-picker',
                    subType: 'time',
                    appendIcon: 'mdi-clock',
                    format: FORMATS.timeShort,
                    placeholder: FORMATS.timeShort,
                    creatable: true,
                    editable: true,
                    visible: this.typeDependantFields.active_from.visible
                  },
                  {
                    key: 'active_to',
                    label: this.$t('satellite-tracking/alarm.active_to'),
                    type: 'datetime-picker',
                    subType: 'time',
                    appendIcon: 'mdi-clock',
                    format: FORMATS.timeShort,
                    placeholder: FORMATS.timeShort,
                    creatable: true,
                    editable: true,
                    visible: this.typeDependantFields.active_to.visible
                  },
                  {
                    key: 'notify_driver',
                    label: this.$t('satellite-tracking.send_to_driver'),
                    type: 'base-switch',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'user_id',
                    label: this.$t('satellite-tracking/alarm.user'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'base',
                      route: 'users/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: this.adminFieldsVisibility.user.visible
                  },
                  {
                    key: 'is_editable',
                    label: this.$t('satellite-tracking/alarm.is_editable'),
                    type: 'base-switch',
                    creatable: true,
                    editable: true,
                    visible: this.adminFieldsVisibility.user.visible
                  },
                  // type dynamic fields
                  // visible when alarm type is selected
                  {
                    key: 'maxSpeed',
                    label: this.$t('satellite-tracking/alarm.max_speed'),
                    field_type: 'number',
                    creatable: true,
                    editable: true,
                    visible: this.typeDependantFields.maxSpeed.visible
                  },
                  {
                    key: 'engineRpmSpeed',
                    label: this.$t('satellite-tracking/alarm.max_engine_rpm_speed'),
                    field_type: 'number',
                    creatable: true,
                    editable: true,
                    visible: this.typeDependantFields.engineRpmSpeed.visible
                  },
                  {
                    key: 'inactivityTime',
                    label: this.$t('satellite-tracking/alarm.inactivity_time'),
                    field_type: 'number',
                    creatable: true,
                    editable: true,
                    visible: this.typeDependantFields.inactivityTime.visible
                  },
                  {
                    key: 'voltageLevel',
                    label: this.$t('satellite-tracking/alarm.voltage_level'),
                    field_type: 'number',
                    creatable: true,
                    editable: true,
                    visible: this.typeDependantFields.voltageLevel.visible
                  },
                  {
                    key: 'location',
                    label: this.$t('satellite-tracking/alarm.location'),
                    appendIcon: 'mdi-map-marker',
                    readonly: true,
                    appendIconClick: (event) => this.openLocationPicker(event),
                    onClick: (event) => this.openLocationPicker(event),
                    options: {
                      custom_display_value: (val) => {
                        return val?.name || ''
                      }
                    },
                    creatable: true,
                    editable: true,
                    visible: this.typeDependantFields.location.visible
                  },
                  {
                    key: 'geofenceEnter',
                    label: this.$t('satellite-tracking/alarm.notify_after'),
                    type: 'autocomplete',
                    items: this.geofenceEnterItems,
                    autocomplete_options: {
                      fetchInitial: false
                    },
                    creatable: true,
                    editable: true,
                    visible: this.typeDependantFields.geofenceEnter.visible
                  },
                  {
                    key: 'sensor',
                    label: this.$t('satellite-tracking/report.select_sensor'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'satellite-tracking',
                      route: 'alarms/sensorTypes/autocomplete',
                      returnValue: 'object'
                    },
                    creatable: true,
                    editable: true,
                    visible: this.typeDependantFields.sensor.visible,
                    onChange: (event) => this.onSensorChange(event)
                  },
                  {
                    key: 'speedLimitTolerance',
                    label: this.$t('satellite-tracking/alarm.speed_limit_tolerance'),
                    field_type: 'number',
                    creatable: true,
                    editable: true,
                    visible: this.typeDependantFields.speedLimitTolerance.visible
                  },
                  {
                    key: 'allowedVehicleUseFrom',
                    label: this.$t('satellite-tracking/alarm.allowed_vehicle_use_from'),
                    type: 'datetime-picker',
                    subType: 'time',
                    appendIcon: 'mdi-clock',
                    format: FORMATS.timeShort,
                    placeholder: FORMATS.timeShort,
                    creatable: true,
                    editable: true,
                    visible: this.typeDependantFields.allowedVehicleUseFrom.visible
                  },
                  {
                    key: 'allowedVehicleUseTo',
                    label: this.$t('satellite-tracking/alarm.allowed_vehicle_use_to'),
                    type: 'datetime-picker',
                    subType: 'time',
                    appendIcon: 'mdi-clock',
                    format: FORMATS.timeShort,
                    placeholder: FORMATS.timeShort,
                    creatable: true,
                    editable: true,
                    visible: this.typeDependantFields.allowedVehicleUseTo.visible
                  },
                  {
                    key: 'ignoreUserAndPartnerLocations',
                    label: this.$t('satellite-tracking/alarm.ignore_user_and_partner_locations'),
                    type: 'base-switch',
                    creatable: true,
                    editable: true,
                    visible: this.typeDependantFields.ignoreUserAndPartnerLocations.visible
                  },
                  {
                    key: 'ignoreUnloadedVehicle',
                    label: this.$t('satellite-tracking/alarm.ignore_unloaded_vehicle'),
                    type: 'base-switch',
                    creatable: true,
                    editable: true,
                    visible: this.typeDependantFields.ignoreUnloadedVehicle.visible
                  },
                  {
                    key: 'ignoreMainLocations',
                    label: this.$t('satellite-tracking/alarm.ignore_main_locations'),
                    type: 'base-switch',
                    creatable: true,
                    editable: true,
                    visible: this.typeDependantFields.ignoreMainLocations.visible
                  },
                  {
                    key: 'temperatureRange',
                    label: this.$t('satellite-tracking/alarm.temperature_range'),
                    type: 'range-slider',
                    min: -55,
                    max: 110,
                    creatable: true,
                    editable: true,
                    disabled: false,
                    visible: this.typeDependantFields.temperatureRange.visible
                  },
                  {
                    key: 'timeTolerance',
                    label: this.$t('satellite-tracking/alarm.time_tolerance'),
                    type: 'slider',
                    creatable: true,
                    editable: true,
                    disabled: false,
                    visible: this.typeDependantFields.timeTolerance.visible
                  },
                  // sensor dynamic fields
                  // visible when sensor is selected
                  {
                    key: 'dinNotifyAfter',
                    label: this.$t('satellite-tracking/alarm.notify_after'),
                    type: 'autocomplete',
                    items: this.dinSensorsNotifyAfterItems,
                    autocomplete_options: {
                      fetchInitial: false
                    },
                    creatable: true,
                    editable: true,
                    visible: this.sensorDependantFields.dinNotifyAfter.visible
                  },
                  {
                    key: 'ainNotifyAfter',
                    label: this.$t('satellite-tracking/alarm.notify_after'),
                    type: 'autocomplete',
                    items: this.ainSensorsNotifyAfterItems,
                    autocomplete_options: {
                      fetchInitial: false
                    },
                    creatable: true,
                    editable: true,
                    visible: this.sensorDependantFields.ainNotifyAfter.visible
                  },
                  {
                    key: 'ainVoltageLimit',
                    label: this.$t('satellite-tracking/alarm.sensor_voltage_limit'),
                    field_type: 'number',
                    creatable: true,
                    editable: true,
                    visible: this.sensorDependantFields.ainVoltageLimit.visible
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
    onCancelSave (event) {
      // CREATE
      if (this.createMode) {
        this.createMode = false
      }
      // EDIT
      else {
        const { cancelTabSave } = event || {}
        cancelTabSave?.()
      }
    },

    afterCancel (event) {
      if (!this.createMode) {
        const { formDataForSend } = event || {}
        const { type: alarmType, options } = formDataForSend || {}
        const alarmTypeId = alarmType?.id || alarmType
        const sensorTypeId = options?.sensor_type || null

        if (alarmTypeId) {
          // show alarm type dynamic fields
          this.handleDynamicFields(alarmTypeId, ALARM_TYPE_DEPENDANT_KEY)
          // show sensor type dynamic fields
          if (sensorTypeId) {
            this.handleDynamicFields(sensorTypeId, SENSOR_TYPE_DEPENDANT_KEY)
          }
          this.mapEditDynamicFieldsData(formDataForSend)
        }
      }
    },

    backToMainTable () {
      // CREATE
      if (this.createMode) {
        this.createMode = false
      }
      // EDIT
      else {
        this.$router.replace({ name: 'Alarms' }).then()
      }
    },

    afterSave (event) {
      // CREATE
      if (this.createMode) {
        this.createMode = false
        const { fetchData } = registeredTableHandlers?.alarms || {}
        fetchData?.()
      }
      // EDIT
      else {
        this.afterCancel(event)
      }
    },

    onModifyDataBeforeSend (event) {
      const { copiedData } = event || {}
      const { type_id: alarmType, sensor } = copiedData || {}

      // skip if alarm type is not valid
      if (!alarmType) {
        return
      }

      // ---- firstly map data that are always being sent ----

      // map vehicles to array of vehicles ids
      if (copiedData?.vehicles?.length) {
        copiedData.vehicles = copiedData?.vehicles?.map(vehicle => vehicle?.id || vehicle)?.filter(vehicle => vehicle) || []
      }
      if (copiedData?.type_id) {
        copiedData.type_id = copiedData.type_id?.id || copiedData?.type_id
      }
      if (copiedData?.frequency_id) {
        copiedData.frequency_id = copiedData.frequency_id?.id || copiedData.frequency_id
      }
      // map active days to array of integers (1,2,3 ... 7)
      // each number represents day in week
      if (copiedData?.active_days?.length) {
        copiedData.active_days = copiedData.active_days.map(day => day?.id)?.filter(day => day)
      }
      // map notification types to array of strings (sms, email or without_notifications)
      if (copiedData?.notification_types?.length) {
        copiedData.notification_types = copiedData.notification_types.map(type => type?.id)?.filter(type => type)
      }

      // ---- now map data based on alarm type ----
      const dataMappingByAlarmType = {
        [TYPE_GEOFENCE]: () => {
          copiedData.parameter = [copiedData?.location?.id || copiedData?.location]?.filter(location => location)
          copiedData.options = copiedData?.geofenceEnter?.id || copiedData?.geofenceEnter
          delete copiedData.location
          delete copiedData.geofenceEnter
        },
        [TYPE_OVERSPEED]: () => {
          copiedData.parameter = copiedData?.maxSpeed
          delete copiedData.maxSpeed
        },
        [TYPE_LOW_VOLTAGE]: () => {
          copiedData.parameter = copiedData?.voltageLevel
          delete copiedData.voltageLevel
        },
        [TYPE_INACTIVE]: () => {
          copiedData.parameter = copiedData?.inactivityTime
          delete copiedData.inactivityTime
        },
        [TYPE_LEGAL_OVERSPEED]: () => {
          copiedData.options = copiedData?.speedLimitTolerance
          delete copiedData.speedLimitTolerance
        },
        [TYPE_DOOR_OPENING]: () => {
          copiedData.ignore_main_locations = !!copiedData?.ignoreMainLocations
          copiedData.ignore_user_and_partner_locations = !!copiedData?.ignoreUserAndPartnerLocations
          delete copiedData.ignoreMainLocations
          delete copiedData.ignoreUserAndPartnerLocations
        },
        [TYPE_TEMPERATURE_RANGE]: () => {
          copiedData.temperature_range = copiedData?.temperatureRange
          copiedData.time_tolerance = copiedData?.timeTolerance
          copiedData.ignore_main_locations = !!copiedData?.ignoreMainLocations
          copiedData.ignore_unloaded_vehicle = !!copiedData?.ignoreUnloadedVehicle
          delete copiedData.temperatureRange
          delete copiedData.timeTolerance
          delete copiedData.ignoreMainLocations
          delete copiedData.ignoreUnloadedVehicle
        },
        [TYPE_ENGINE_RPM_OVERSPEED]: () => {
          copiedData.parameter = copiedData?.engineRpmSpeed
          delete copiedData.engineRpmSpeed
        },
        [TYPE_UNAUTHORIZED_VEHICLE_USE]: () => {
          copiedData.active_from = copiedData?.allowedVehicleUseFrom
          copiedData.active_to = copiedData?.allowedVehicleUseTo
          delete copiedData.allowedVehicleUseFrom
          delete copiedData.allowedVehicleUseTo
        },
        [TYPE_SENSORS]: () => {
          copiedData.options = sensor?.id || sensor
          const sensorType = sensor?.type
          if (!sensorType) {
            return
          }

          if (sensorType === TYPE_ANALOG) {
            copiedData.ain_notify = copiedData?.ainNotifyAfter?.id || copiedData?.ainNotifyAfter
            copiedData.ain_voltage_limit = copiedData?.ainVoltageLimit
            delete copiedData.ainNotifyAfter
            delete copiedData.ainVoltageLimit
          }
          else {
            copiedData.din_notify_after = copiedData?.dinNotifyAfter?.id || copiedData?.dinNotifyAfter
            delete copiedData.dinNotifyAfter
          }
          delete copiedData.sensor
        }
      }
      dataMappingByAlarmType?.[alarmType]?.()
      return copiedData
    },

    onAlarmTypeChange (event) {
      const { selectedItem } = event || {}
      const alarmTypeId = selectedItem?.id || selectedItem
      this.handleDynamicFields(alarmTypeId, ALARM_TYPE_DEPENDANT_KEY)
    },

    onSensorChange (event) {
      const { selectedItem } = event || {}
      const sensorTypeId = selectedItem?.type || selectedItem
      this.handleDynamicFields(sensorTypeId, SENSOR_TYPE_DEPENDANT_KEY)
    },

    handleDynamicFields (value, field) {
      // skip if value is not provided
      // value can be alarm type id or sensor type id
      if (!value) {
        return
      }
      this.hideAllDynamicFields()
      this.clearFields()

      this.$set(this.typeDependantFields.active_from, 'visible', value !== TYPE_UNAUTHORIZED_VEHICLE_USE)
      this.$set(this.typeDependantFields.active_to, 'visible', value !== TYPE_UNAUTHORIZED_VEHICLE_USE)
      const mapFields = {
        [ALARM_TYPE_DEPENDANT_KEY]: () => {
          // skip if alarm type is fuel leak
          // it does not have dynamic fields
          if (value === TYPE_FUEL_LEAK) {
            return
          }
          return {
            [TYPE_GEOFENCE]: () => {
              this.$set(this.typeDependantFields.location, 'visible', true)
              this.$set(this.typeDependantFields.geofenceEnter, 'visible', true)
            },
            [TYPE_OVERSPEED]: () => {
              this.$set(this.typeDependantFields.maxSpeed, 'visible', true)
            },
            [TYPE_LOW_VOLTAGE]: () => {
              this.$set(this.typeDependantFields.voltageLevel, 'visible', true)
            },
            [TYPE_INACTIVE]: () => {
              this.$set(this.typeDependantFields.inactivityTime, 'visible', true)
            },
            [TYPE_LEGAL_OVERSPEED]: () => {
              this.$set(this.typeDependantFields.speedLimitTolerance, 'visible', true)
            },
            [TYPE_DOOR_OPENING]: () => {
              this.$set(this.typeDependantFields.ignoreMainLocations, 'visible', true)
              this.$set(this.typeDependantFields.ignoreUserAndPartnerLocations, 'visible', true)
            },
            [TYPE_TEMPERATURE_RANGE]: () => {
              this.$set(this.typeDependantFields.ignoreMainLocations, 'visible', true)
              this.$set(this.typeDependantFields.ignoreUnloadedVehicle, 'visible', true)
              this.$set(this.typeDependantFields.temperatureRange, 'visible', true)
              this.$set(this.typeDependantFields.timeTolerance, 'visible', true)
            },
            [TYPE_ENGINE_RPM_OVERSPEED]: () => {
              this.$set(this.typeDependantFields.engineRpmSpeed, 'visible', true)
            },
            [TYPE_SENSORS]: () => {
              this.$set(this.typeDependantFields.sensor, 'visible', true)
            },
            [TYPE_UNAUTHORIZED_VEHICLE_USE]: () => {
              this.$set(this.typeDependantFields.allowedVehicleUseFrom, 'visible', true)
              this.$set(this.typeDependantFields.allowedVehicleUseTo, 'visible', true)
            },
            [TYPE_DRIVING_WITHOUT_DRIVER]: () => {
              return undefined
            }
          }
        },
        [SENSOR_TYPE_DEPENDANT_KEY]: () => {
          return {
            [TYPE_ANALOG]: () => {
              this.$set(this.typeDependantFields.sensor, 'visible', true)
              this.$set(this.sensorDependantFields.ainNotifyAfter, 'visible', true)
              this.$set(this.sensorDependantFields.ainVoltageLimit, 'visible', true)
            },
            [TYPE_DIGITAL]: () => {
              this.$set(this.typeDependantFields.sensor, 'visible', true)
              this.$set(this.sensorDependantFields.dinNotifyAfter, 'visible', true)
            }
          }
        }
      }

      mapFields?.[field]?.()?.[value]()
    },

    hideAllDynamicFields () {
      const hideFields = (fields) => {
        Object.keys(fields).forEach(key => {
          const field = fields[key]
          if (field && field.visible !== undefined) {
            this.$set(fields[key], 'visible', false)
          }
        })
      }

      hideFields(this.typeDependantFields)
      hideFields(this.sensorDependantFields)
    },

    clearFields () {
      if (this.createMode) {
        const { updateData } = registeredTabsHandlers?.basicInfo || {}
        this.$set(this.locationPickerConfig, 'refreshLocations', true)
        updateData?.({
          location: null
        })
      }
    },

    openLocationPicker (event) {
      const { createMode, editMode } = event || {}
      if (!editMode && !createMode) {
        return
      }

      this.$set(this.locationPickerConfig, 'title', createMode || editMode ? this.$t('satellite-tracking/alarm.select_location') : this.$t('satellite-tracking/alarm.location_preview'))
      this.$set(this.locationPickerConfig, 'show', true)
    },

    onDataFetched (event) {
      const { data, meta } = event?.data || {}
      const { type: alarmType, options } = data || {}
      const alarmTypeId = alarmType?.id || alarmType
      const sensorTypeId = options?.sensor_type || null

      this.$set(this.adminFieldsVisibility.user, 'visible', !!meta?.user)
      this.$set(this.adminFieldsVisibility.is_editable, 'visible', !!meta?.is_editable)
      if (alarmTypeId) {
        // show alarm type dynamic fields
        this.handleDynamicFields(alarmTypeId, ALARM_TYPE_DEPENDANT_KEY)
        // show sensor type dynamic fields
        if (sensorTypeId) {
          this.handleDynamicFields(sensorTypeId, SENSOR_TYPE_DEPENDANT_KEY)
        }
        this.mapEditDynamicFieldsData(data)
      }
    },

    mapEditDynamicFieldsData (data) {
      const { type: alarmType, vehicles, options, frequency, user } = data || {}
      const alarmTypeId = alarmType?.id || alarmType || null
      const { updateData } = registeredTabsHandlers?.basicInfo || {}

      const setFormData = updateData
      // skip if type is not provided
      if (!alarmTypeId || typeof setFormData !== 'function') {
        return
      }

      setFormData({
        type_id: alarmTypeId,
        user_id: user?.id || user,
        frequency_id: frequency?.id || frequency,
        vehicles: vehicles?.map(vehicle => vehicle?.id)?.filter(vehicle => vehicle) || []
      })

      // map form data based on alarm type
      const dataMapping = {
        [TYPE_GEOFENCE]: () => {
          if (data?.[this.typeDependantFields.location.mapKey]?.[0]) {
            setFormData({
              location: data[this.typeDependantFields.location.mapKey][0],
              geofenceEnter: data?.options
            })
            this.$set(this.locationPickerConfig, 'value', [data[this.typeDependantFields.location.mapKey][0]?.id])
          }
        },
        [TYPE_OVERSPEED]: () => {
          if (data?.[this.typeDependantFields.maxSpeed.mapKey]) {
            setFormData({
              maxSpeed: data[this.typeDependantFields.maxSpeed.mapKey]
            })
          }
        },
        [TYPE_LOW_VOLTAGE]: () => {
          if (data?.[this.typeDependantFields.voltageLevel.mapKey]) {
            setFormData({
              voltageLevel: data[this.typeDependantFields.voltageLevel.mapKey]
            })
          }
        },
        [TYPE_INACTIVE]: () => {
          if (data?.[this.typeDependantFields.inactivityTime.mapKey]) {
            setFormData({
              inactivityTime: data[this.typeDependantFields.inactivityTime.mapKey]
            })
          }
        },
        [TYPE_LEGAL_OVERSPEED]: () => {
          if (data?.[this.typeDependantFields.speedLimitTolerance.mapKey]) {
            setFormData({
              speedLimitTolerance: data[this.typeDependantFields.speedLimitTolerance.mapKey]
            })
          }
        },
        [TYPE_DOOR_OPENING]: () => {
          // get key parts because data is inside object
          const ignoreMainDoorKeyParts = this.typeDependantFields.ignoreMainLocations.mapKey?.includes('.') ? this.typeDependantFields.ignoreMainLocations.mapKey.split('.') : []
          const ignoreUserAndPartnerDoorKeyParts = this.typeDependantFields.ignoreUserAndPartnerLocations.mapKey?.includes('.') ? this.typeDependantFields.ignoreUserAndPartnerLocations.mapKey.split('.') : []

          // update form data
          if (ignoreMainDoorKeyParts?.length === 2) {
            setFormData({
              ignoreMainLocations: data[ignoreMainDoorKeyParts[0]][ignoreMainDoorKeyParts[1]]
            })
          }
          if (ignoreUserAndPartnerDoorKeyParts?.length === 2) {
            setFormData({
              ignoreUserAndPartnerLocations: data[ignoreUserAndPartnerDoorKeyParts[0]][ignoreUserAndPartnerDoorKeyParts[1]]
            })
          }
        },
        [TYPE_TEMPERATURE_RANGE]: () => {
          // get key parts because data is inside object
          const tempRangeKeyParts = this.typeDependantFields.temperatureRange.mapKey?.includes('.') ? this.typeDependantFields.temperatureRange.mapKey.split('.') : []
          const timeToleranceKeyParts = this.typeDependantFields.timeTolerance.mapKey?.includes('.') ? this.typeDependantFields.timeTolerance.mapKey.split('.') : []
          const ignoreMainTempRangeKeyParts = this.typeDependantFields.ignoreMainLocations.mapKey?.includes('.') ? this.typeDependantFields.ignoreMainLocations.mapKey.split('.') : []
          const ignoreUnloadedTempRangeKeyParts = this.typeDependantFields.ignoreUnloadedVehicle.mapKey?.includes('.') ? this.typeDependantFields.ignoreUnloadedVehicle.mapKey.split('.') : []

          // update form data
          if (ignoreMainTempRangeKeyParts?.length === 2) {
            setFormData({
              ignoreMainLocations: data[ignoreMainTempRangeKeyParts[0]][ignoreMainTempRangeKeyParts[1]]
            })
          }
          if (ignoreUnloadedTempRangeKeyParts?.length === 2) {
            setFormData({
              ignoreUnloadedVehicle: data[ignoreUnloadedTempRangeKeyParts[0]][ignoreUnloadedTempRangeKeyParts[1]]
            })
          }
          if (tempRangeKeyParts?.length === 2) {
            setFormData({
              temperatureRange: data[tempRangeKeyParts[0]][tempRangeKeyParts[1]]
            })
          }
          if (timeToleranceKeyParts?.length === 2) {
            setFormData({
              timeTolerance: data[timeToleranceKeyParts[0]][timeToleranceKeyParts[1]]
            })
          }
        },
        [TYPE_ENGINE_RPM_OVERSPEED]: () => {
          if (data?.[this.typeDependantFields.engineRpmSpeed.mapKey]) {
            setFormData({
              engineRpmSpeed: data[this.typeDependantFields.engineRpmSpeed.mapKey]
            })
          }
        },
        [TYPE_UNAUTHORIZED_VEHICLE_USE]: () => {
          if (data?.active_from) {
            setFormData({
              allowedVehicleUseFrom: data.active_from
            })
          }
          if (data?.active_to) {
            setFormData({
              allowedVehicleUseTo: data.active_to
            })
          }
        },
        [TYPE_DRIVING_WITHOUT_DRIVER]: () => {
          return undefined
        },
        [TYPE_SENSORS]: () => {
          const { sensor_id: sensorId, sensor_type: sensorType } = options || {}
          if (!sensorType) {
            return
          }

          setFormData({
            sensor: sensorId ? parseInt(sensorId) : null
          })
          if (sensorType === TYPE_ANALOG) {
            setFormData({
              ainNotifyAfter: data?.options?.ain_notify_after,
              ainVoltageLimit: data?.options?.ain_voltage_limit
            })
          }
          else {
            setFormData({
              dinNotifyAfter: data?.options?.din_notify_after
            })
          }
        }
      }
      dataMapping?.[alarmTypeId]?.()
    }
  }
}
